import consumer from "./consumer"
let current_user
let mode_user
const officeMeetingReminderPendingKey = 'officeMeetingReminderPending'
const officeMeetingReminderQueue = []
let officeMeetingReminderVisible = false
let officeMeetingReminderPageReady = false
let officeMeetingReminderTimer

function officeMeetingReminderKey(content) {
    return `officeMeetingReminder:${content.site_visit_id}:${content.scheduled_at}`
}

function pendingOfficeMeetingReminders() {
    try {
        return JSON.parse(sessionStorage.getItem(officeMeetingReminderPendingKey) || '[]')
    } catch (error) {
        sessionStorage.removeItem(officeMeetingReminderPendingKey)
        return []
    }
}

function savePendingOfficeMeetingReminders(reminders) {
    sessionStorage.setItem(officeMeetingReminderPendingKey, JSON.stringify(reminders))
}

function rememberOfficeMeetingReminder(content) {
    const reminderKey = officeMeetingReminderKey(content)
    const reminders = pendingOfficeMeetingReminders()

    if (!reminders.some((reminder) => officeMeetingReminderKey(reminder) === reminderKey)) {
        reminders.push(content)
        savePendingOfficeMeetingReminders(reminders)
    }
}

function removePendingOfficeMeetingReminder(reminderKey) {
    const reminders = pendingOfficeMeetingReminders().filter((reminder) => {
        return officeMeetingReminderKey(reminder) !== reminderKey
    })
    savePendingOfficeMeetingReminders(reminders)
}

function queueHasOfficeMeetingReminder(reminderKey) {
    return officeMeetingReminderQueue.some((reminder) => {
        return officeMeetingReminderKey(reminder) === reminderKey
    })
}

function escapeOfficeMeetingReminderText(value) {
    return $('<div>').text(value || '').html()
}

function officeMeetingReminderUrl(content) {
    const scheduledAt = new Date(content.scheduled_at)
    if (Number.isNaN(scheduledAt.getTime())) return '/site_visits'

    const viewDate = content.view_date || [
        String(scheduledAt.getMonth() + 1).padStart(2, '0'),
        String(scheduledAt.getDate()).padStart(2, '0'),
        scheduledAt.getFullYear()
    ].join('/')
    const date = String(viewDate).includes(':') ? viewDate : `${viewDate} 12:00 AM`
    const currentParams = new URLSearchParams(window.location.search)
    const providerUserId = content.provider_user_id ||
        content.provider_id ||
        content.created_by ||
        currentParams.get('provider_user_id') ||
        currentParams.get('provider_id') ||
        $('#current_provider_user_id').val()
    const params = new URLSearchParams({
        date: date,
        belongs_to: content.user_mode ? 'others' : 'me',
        category: 'office-meeting',
        id: content.site_visit_id
    })

    if (content.user_mode && providerUserId) {
        params.set('provider_user_id', providerUserId)
    }

    return `/site_visits_on_date?${params.toString()}`
}

function officeMeetingReminderBlockedByPageState() {
    const modalIsOpen = document.body.classList.contains('modal-open') ||
        $('.modal.show:visible, .modal.in:visible, .modal-backdrop:visible').length > 0
    const loaderIsOpen = $('#loader:visible, .js-loading-overlay:visible, .loading-state:visible, .meeting-loading-state:visible').length > 0

    return modalIsOpen || loaderIsOpen
}

function scheduleOfficeMeetingReminderPopup() {
    clearTimeout(officeMeetingReminderTimer)

    officeMeetingReminderTimer = setTimeout(() => {
        showNextOfficeMeetingReminder()
    }, officeMeetingReminderPageReady ? 1200 : 500)
}

function showNextOfficeMeetingReminder() {
    if (!officeMeetingReminderPageReady || document.readyState !== 'complete') {
        scheduleOfficeMeetingReminderPopup()
        return
    }
    if (officeMeetingReminderBlockedByPageState()) {
        scheduleOfficeMeetingReminderPopup()
        return
    }
    if (officeMeetingReminderVisible || officeMeetingReminderQueue.length === 0) return

    const content = officeMeetingReminderQueue.shift()
    const reminderKey = officeMeetingReminderKey(content)

    if (!window.Swal || typeof window.Swal.fire !== 'function') {
        console.error('SweetAlert is unavailable for the office meeting reminder', content)
        officeMeetingReminderQueue.unshift(content)
        scheduleOfficeMeetingReminderPopup()
        return
    }

    officeMeetingReminderVisible = true
    const meetingName = escapeOfficeMeetingReminderText(content.meeting_name || content.title || 'Office Meeting')
    const reminderMessage = escapeOfficeMeetingReminderText(content.message)

    window.Swal.fire({
        title: 'Meeting Reminder',
        html: `
            <div style="margin-top:4px;">
                <div style="display:inline-flex;align-items:center;gap:8px;padding:7px 14px;
                            background:#fff4ed;color:#d85f24;border:1px solid #ffd8c2;
                            border-radius:20px;font-size:14px;font-weight:700;margin-bottom:14px;">
                    <i class="fas fa-calendar-alt"></i>
                    <span>${meetingName}</span>
                </div>
                <div style="color:#475569;font-size:16px;line-height:1.55;max-width:430px;margin:0 auto;">
                    ${reminderMessage}
                </div>
            </div>
        `,
        icon: 'info',
        iconColor: '#E86C2E',
        showCancelButton: true,
        confirmButtonText: '<i class="fas fa-eye" style="font-size:12px;margin-right:6px;"></i><span>View Meeting</span>',
        cancelButtonText: 'Dismiss',
        confirmButtonColor: '#E86C2E',
        cancelButtonColor: '#dc3545',
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 520,
        padding: '2rem',
        didOpen: (popup) => {
            popup.style.borderTop = '5px solid #E86C2E'
            popup.style.borderRadius = '14px'
            popup.style.boxShadow = '0 18px 50px rgba(15, 23, 42, 0.22)'

            const title = popup.querySelector('.swal2-title')
            if (title) {
                title.style.color = '#4a4a4a'
                title.style.fontSize = '20px'
                title.style.fontWeight = '700'
            }

            const htmlContainer = popup.querySelector('.swal2-html-container')
            if (htmlContainer) {
                htmlContainer.style.margin = '0.75rem 1.4rem 0'
            }

            const actions = popup.querySelector('.swal2-actions')
            if (actions) {
                actions.style.gap = '10px'
                actions.style.marginTop = '22px'
            }

            const applyButtonStyle = (button, color) => {
                if (!button) return

                button.style.alignItems = 'center'
                button.style.background = color
                button.style.border = `1px solid ${color}`
                button.style.borderRadius = '8px'
                button.style.boxShadow = 'none'
                button.style.color = '#ffffff'
                button.style.display = 'inline-flex'
                button.style.fontSize = '14px'
                button.style.fontWeight = '700'
                button.style.justifyContent = 'center'
                button.style.lineHeight = '1.2'
                button.style.minHeight = '34px'
                button.style.minWidth = '92px'
                button.style.padding = '8px 14px'
                button.style.transition = 'all 0.18s ease'

                button.addEventListener('mouseenter', () => {
                    button.style.background = '#ffffff'
                    button.style.color = color
                })
                button.addEventListener('mouseleave', () => {
                    button.style.background = color
                    button.style.color = '#ffffff'
                })
            }

            applyButtonStyle(popup.querySelector('.swal2-confirm'), '#E86C2E')
            applyButtonStyle(popup.querySelector('.swal2-cancel'), '#dc3545')
        }
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = officeMeetingReminderUrl(content)
        }
    }).finally(() => {
        sessionStorage.setItem(reminderKey, 'shown')
        removePendingOfficeMeetingReminder(reminderKey)
        officeMeetingReminderVisible = false
        showNextOfficeMeetingReminder()
    })
}

function enqueueOfficeMeetingReminder(content) {
    const reminderKey = officeMeetingReminderKey(content)
    if (sessionStorage.getItem(reminderKey)) return
    if (queueHasOfficeMeetingReminder(reminderKey)) return

    rememberOfficeMeetingReminder(content)
    officeMeetingReminderQueue.push(content)
    scheduleOfficeMeetingReminderPopup()
}

function loadPendingOfficeMeetingReminders() {
    pendingOfficeMeetingReminders().forEach((content) => {
        const reminderKey = officeMeetingReminderKey(content)
        if (!sessionStorage.getItem(reminderKey) && !queueHasOfficeMeetingReminder(reminderKey)) {
            officeMeetingReminderQueue.push(content)
        }
    })
    scheduleOfficeMeetingReminderPopup()
}

function markOfficeMeetingReminderPageReady() {
    officeMeetingReminderPageReady = true
    loadPendingOfficeMeetingReminders()
}

if (document.readyState === 'complete') {
    setTimeout(markOfficeMeetingReminderPageReady, 800)
} else {
    window.addEventListener('load', () => {
        setTimeout(markOfficeMeetingReminderPageReady, 800)
    })
}

consumer.subscriptions.create("NotificationChannel", {
    connected() {
        // Called when the subscription is ready for use on the server
        current_user = $('#current_user_id').val();
        mode_user = $('#current_user_mode').val();
        let current_profile = $('#current_user_profile').val(); // provider, employee, owner etc.
        if (current_user !== "" && current_user !== "undefined" && current_user !== undefined) {
            let notificationCount = sessionStorage.getItem('unreadNotificationCount');
            if (notificationCount !== null) {
                // If count is present in sessionStorage, use it
                updateNotificationCount(notificationCount);
            } else {
                let mode = mode_user === 'true'
                $.ajax({
                    type: 'get',
                    url: '/unread_notification_count',
                    data: {usermode: mode, profile_type: current_profile},
                    success: function (data) {

                            let  count = data.response.data
                            sessionStorage.setItem('unreadNotificationCount', count);
                            updateNotificationCount(count);
                    }
                })
            }
        }
    },

    disconnected() {
        // Called when the subscription has been terminated by the server
    },

    received(data) {
        // Called when there's incoming data on the websocket for this channel
        if (!data || !data.content) return

        const content = data.content
        const currentUserId = parseInt($('#current_user_id').val(), 10)
        let mode = mode_user === 'true'
        if (content.emp_user_id && (currentUserId === content.emp_user_id)) {
            let element = `<a href="/view_task/${data.content.task_id}?admin=${data.content.admin}&amp;has_valid_emp_role=${data.content.has_valid_emp_role}&amp;provider=${data.content.provider_id}">
                            ${data.content.message}
                            </a>`
            if (data.content.success == "true") {
                toastr.info(element)
            }
        }
        if ((mode === data.content.user_mode) && (data.content.refer_to === parseInt(current_user))){
            $("#noty").removeClass("d-block").addClass("d-none");
            $("#live-noty").removeClass("d-none").addClass("d-block");
            $(".notifi").addClass("noty-bell");
            let divTag = $('#nav-noti-count')
            let countData = divTag.text();
            if (countData === '' || countData === 'undefined'){
                countData = 0;
            }
            let newCount = parseInt(countData) + 1;
            divTag.text(newCount).removeClass('d-none');
            sessionStorage.setItem('unreadNotificationCount', String(newCount));

        }
        if ((mode === data.content.user_mode) && (data.content.refer_to === parseInt(current_user)) && (data.content.notify_count_id) ){
            let countSpan = $(`#${data.content.notify_count_id}`)
            let countData = countSpan.text();
            if (countData === '' || countData === 'undefined'){
                countData = 0;
            }
            let resultData = parseInt(countData) + parseInt(data.content.layout_count)
            countSpan.text(resultData.toString());
        }
        if (data.content.notification_type && data.content.notification_type == "provider_payment_request") {
            if (data.content.refer_to === parseInt(current_user)) {
                const selector = `.service-provider-payment-count-pendin_${data.content.contract_id}`;
                const $elem = $(selector);
                $(selector).removeClass('d-none')
                if ($(selector).length) {
                    const count = parseInt($elem.text()) || 0;
                    $elem.text(count + 1).removeClass('d-none').show();
                }
            }
        }

        if (content.notification_type === "office_meeting_reminder" &&
            content.refer_to === currentUserId) {
            enqueueOfficeMeetingReminder(content)
        }
    }
});





function updateNotificationCount(count) {
    // If the count is greater than 0, show the count and the live icon
    if (count > 0) {
        $('#nav-noti-count').text(count).removeClass('d-none');
        $("#noty").removeClass("d-block").addClass("d-none");
        $("#live-noty").removeClass("d-none").addClass("d-block");
        $(".notifi").addClass("noty-bell");
    } else {
        // If the count is 0, hide the count and show only the icon
        $('#nav-noti-count').addClass('d-none');
        $("#live-noty").removeClass("d-block").addClass("d-none");
        $("#noty").removeClass("d-none").addClass("d-block");
    }
}
